import { zodSchemes } from '@approvalmax/utils';
import { CountryIsoCode } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { messages } from './messages';

export const schema = z
    .object({
        accountUsage: z
            .object({
                transactionCountries: zodSchemes.required.select
                    .enum(CountryIsoCode)
                    .array()
                    // use `min` instead of `nonempty` because the second generates types that
                    // aren't compatible w/ the API types `[T, ...T[]]` vs `T[]`
                    .min(1, messages.requiredField),
                collectionCurrencies: z.array(z.string()).optional(),
                paymentCurrencies: z.array(z.string()).optional(),
            })
            .passthrough(),
    })
    .passthrough();
